import { isLiquidGlassSupported } from "@-/com.npmjs.callstack__liquid-glass";

/**
 * The frame a menu's content draws around `MenuPopoverSurface`. On iOS Liquid Glass there is none,
 * as around a system menu's platter: no border, no shadow of its own and no clipping, since the
 * glass draws its own rim and shadow past its bounds. Elsewhere a hairline border and shadow frame
 * the blur.
 */
export const MENU_POPOVER_FRAME_CLASS_NAME = isLiquidGlassSupported
  ? ""
  : "overflow-hidden rounded-xs border border-border shadow-lg shadow-black/5";
